import { render, staticRenderFns } from "./ImmersiveNavbar.vue?vue&type=template&id=f74bddb2&scoped=true&"
import script from "./ImmersiveNavbar.vue?vue&type=script&lang=ts&"
export * from "./ImmersiveNavbar.vue?vue&type=script&lang=ts&"
import style0 from "./ImmersiveNavbar.vue?vue&type=style&index=0&id=f74bddb2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f74bddb2",
  null
  
)

export default component.exports